import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  separator: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '.8rem',
    '& p': {
      padding: theme.spacing(0, 5),
      color: theme.palette.text.disabled,
    },
    '& span': {
      flexGrow: '1',
      width: '50%',
      height: '2px',
      backgroundColor: theme.palette.grey[300],
    },
  },
}));

export default useStyles;
